// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityCreate_container__3ib4R","form":"ActivityCreate_form__l0m99"};